export * from "/builds/t2_e_sw-P/0/dd3tech/wiggot/wiggot-web/packages/web-components/layouts/MinimalistStepLayout/MinimalistStepLayout.tsx"